var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"22vh","width":"22vh"},attrs:{"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }